import { Button } from '@avanta/shared/components/ui/Button';
import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { useDialogContext } from '@avanta/shared/contexts/Dialog';
import { t } from '@avanta/shared/i18n';
import { X } from 'lucide-react';
import { CancelAppointmentDialog } from './CancelAppointmentDialog';
import { type CancelAppointmentProps } from './types';

export const CancelAppointment = ({
  appointment,
  icon,
  buttonLabel = t('CancelSessionDialog.cta', { ns: LOCIZE_NS.INSURANCE }),
  className,
}: CancelAppointmentProps): React.ReactElement => {
  const { showDialog } = useDialogContext();

  const handleCancelClick = (): void => {
    showDialog({ component: <CancelAppointmentDialog appointment={appointment} /> });
  };

  return (
    <Button
      variant="destructive_terciary"
      size="lg"
      className={className}
      onClick={handleCancelClick}
      icon={icon ?? 'leading'}
    >
      <X className="size-6" />
      {icon !== 'only' && buttonLabel}
    </Button>
  );
};
